export const rightList = [
    [{
        value: '权益名称'
    }, {
        value: '权益效果'
    }, {
        value: '律所会员'
    }, {
        value: '非会员'
    }],
    [{
        value: '律所名片卡'
    }, {
        value: '精准搜索律所名字，专属名片卡展现，塑造价值C位'
    }, {
        value: '会员专属样式，一年期有效'
    }, {
        value: ''
    }],
    [{
        value: '律所推荐卡'
    }, {
        value: '泛化搜索城市+律所，会员严选标识，推荐排名优先'
    }, {
        value: '会员有效期内绝对优先展示'
    }, {
        value: ''
    }],
    [{
        value: '法律内容署名'
    }, {
        value: '千万级法律问答库，会员免费署名权益，用内容丰富权威，进一步触达搜索用户'
    }, {
        value: '200条/年，可授权使用'
    }, {
        value: ''
    }],
    [{
        value: '专属律所主页'
    }, {
        value: '专属律所主页，个性化自定义配置，提升律所品牌形象'
    }, {
        value: '会员专属样式，一年期有效'
    }, {
        value: ''
    }],
    [{
        value: '律临站点推荐'
    }, {
        value: '律临站点律所优先推荐，加强曝光'
    }, {
        value: '会员有效期内绝对优先展示'
    }, {
        value: ''
    }],
    [{
        value: '律所领域标签'
    }, {
        value: '匹配相关领域流量及客户资源，精准触达用户'
    }, {
        value: '免费领取4个，支持加购'
    }, {
        value: '2个'
    }],
    [{
        value: '即时线索认领'
    }, {
        value: '每月会员免费认领高意向线索，自由挑选接触转化'
    }, {
        value: '15条/月'
    }, {
        value: ''
    }],
    [{
        value: '公开咨询认领'
    }, {
        value: '海量级线索，会员回复咨询优先获得线索，无限畅领'
    }, {
        value: '无限认领'
    }, {
        value: ''
    }],
    // [{
    //     value: '付费电话咨询'
    // }, {
    //     value: '用户诉求定向触达律所，接受付费咨询方式，高效知识变现，并可直显用户真实号码'
    // }, {
    //     value: '一年期有效'
    // }, {
    //     value: ''
    // }],
    // [{
    //     value: '在线IM咨询方式'
    // }, {
    //     value: '用户在线咨询，12小时客户独占保护'
    // }, {
    //     value: '一年期有效'
    // }, {
    //     value: ''
    // }],
    [{
        value: '律师专属名片卡'
    }, {
        value: '精准搜索"姓名+律师"，律师名片权威展现'
    }, {
        value: '会员专属样式，一年期有效'
    }, {
        value: ''
    }],
    [{
        value: '律师推荐卡'
    }, {
        value: '搜"地域+领域+律师", 精选认证，优先推荐'
    }, {
        value: '会员有效期内绝对优先展示'
    }, {
        value: ''
    }],
    [{
        value: '律临站点推荐'
    }, {
        value: '律临站点律师优先推荐，加强曝光'
    }, {
        value: '律所授予，有效期内优先展示'
    }, {
        value: ''
    }],
    [{
        value: '律师专属电子名片卡'
    }, {
        value: '专属电子名片卡，进一步提升律师形象'
    }, {
        value: '会员专属样式，一年期有效'
    }, {
        value: ''
    }],
    [{
        value: '律师个人站点'
    }, {
        value: '专属律师主页，个性化自定义配置，会员严选标识进一步提升律师品牌形象'
    }, {
        value: '会员专属样式，一年期有效'
    }, {
        value: ''
    }],
    [{
        value: 'AI合同助手'
    }, {
        value: '基于全行业合同范本，一键生成合同模板，高效提升律师工作效率'
    }, {
        value: '日均5次/不限时'
    }, {
        value: '日均5次/不限时'
    }]
];

export const colorList = [
    [
        '#F8FBFF',
        '#F8FBFF',
        'linear-gradient(134.06deg, rgba(255, 234, 219, 0.35) -8.19%, rgba(255, 242, 216, 0.35) 100%)',
        `linear-gradient(138.21deg, rgba(224, 226, 255, 0.5) 12.93%, rgba(220, 233, 255, 0.5) 88.17%), 
            linear-gradient(0deg, #F2F4F9, #F2F4F9)`
    ],
    [
        '#FFFFFF',
        '#FFFFFF',
        '#FFFCF6',
        '#FFFFFF'
    ]
];

export const fontList = [{
    color: '#1E1F24',
    fontSize: '16px',
    fontWeight: '500'
}, {
    color: '#50525C',
    fontSize: '14px'
}, {
    color: '#79390A',
    fontSize: '14px'
}, {
    color: '#1E1F24',
    fontSize: '14px',
    fontWeight: '500'
}];

// 权益卡片列表
export const cardList = {
    exposure: {
        lockList: [{
            title: '律所品牌卡',
            subtitle: '精准搜索律所名字，专属名片卡展现，塑造价值C位',
            icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/firmIndex/r.png'
        },
        {
            title: '律所推荐卡',
            subtitle: '泛化搜索城市+律所，会员严选标识，推荐排名优先',
            icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/firmIndex/firm-recommend.png'
        },
        {
            title: '法律内容署名',
            subtitle: '千万级法律问答库，会员免费署名权益，用内容丰富权威，进一步触达搜索用户',
            icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/firmIndex/signature.png'
        },
        {
            title: '专属律所主页',
            subtitle: '专属律所主页，个性化自定义配置，会员严选标识进一步提升律所品牌形象',
            icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/firmIndex/firm-home.png'
        },
        {
            title: '律临站点推荐',
            subtitle: '律临站点律所优先推荐，加强曝光',
            icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/firmIndex/lvlin-recommend.png'
        },
        {
            title: '律所领域标签权益',
            subtitle: '免费领取4个领域标签，支持加购',
            icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/firmIndex/label.png'
        }],
        unLockList: null
    },
    member: {
        lockList: [{
            title: '律师专属名片卡',
            subtitle: '精准搜索"姓名+律师"，律师名片权威展现',
            icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/firmIndex/lawyer-card.png'
        }, {
            title: '律师推荐卡',
            subtitle: '搜"地域+领域+律师", 精选认证，优先推荐',
            icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/firmIndex/lawyer-recommend-icon.png'
        }, {
            title: '律临站点推荐',
            subtitle: '律临站点律师优先推荐，加强曝光',
            icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/firmIndex/lvlin-recommend.png'
        }, {
            title: '电子名片卡',
            subtitle: '专属电子名片卡，进一步提升律师形象',
            icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/firmIndex/business-card.png'
        }, {
            title: '个人站点',
            subtitle: '专属律师主页，个性化自定义配置，会员严选标识进一步提升律师品牌形象',
            icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/firmIndex/personal-site.png'
        }],
        unLockList: null
    },
    effect: {
        lockList: [{
            title: '即时线索',
            subtitle: '每月会员免费认领高意向线索，自由挑选接触转化',
            icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/firmIndex/clue-icon.png'
        }, {
            title: '公开咨询',
            subtitle: '海量级线索，会员回复咨询优先获得线索，无限畅领',
            icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/firmIndex/consult.png'
        }],
        // }, {
        //     title: '付费电话咨询',
        //     subtitle: '用户诉求定向触达律师，提供付费咨询方式，高效变现',
        //     icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/firmIndex/phone.png'
        // }, {
        //     title: 'IM咨询',
        //     subtitle: '用户在线咨询，12小时客户独占保护',
        //     icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/firmIndex/im.png'
        // }
        unLockList: null
    },
    tool: {
        lockList: null,
        unLockList: [{
            title: 'AI合同助手',
            subtitle: '一键上传资料，系统A1智能分析材料，80%业务2小时内即可出函',
            icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/firmIndex/ai-active.png'
        }]
    }
};

// 会员权益卡列表
export const vipCardList = {
    exposure: {
        unLockList: [{
            title: '律所品牌卡',
            subtitle: '精准搜索律所名字，专属名片卡展现，塑造价值C位',
            icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/firmIndex/r-vip.png'
        },
        {
            title: '律所推荐卡',
            subtitle: '泛化搜索城市+律所，会员严选标识，推荐排名优先',
            icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/firmIndex/firm-recommend-vip.png'
        },
        {
            title: '法律内容署名',
            subtitle: '千万级法律问答库，会员免费署名权益，用内容丰富权威，进一步触达搜索用户',
            icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/firmIndex/signature-vip.png'
        },
        {
            title: '专属律所主页',
            subtitle: '专属律所主页，个性化自定义配置，会员严选标识进一步提升律所品牌形象',
            icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/firmIndex/firm-home-vip.png'
        },
        {
            title: '律临站点推荐',
            subtitle: '律临站点律所优先推荐，加强曝光',
            icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/firmIndex/lvlin-recommend-vip.png'
        },
        {
            title: '律所领域标签权益',
            subtitle: '免费领取4个领域标签，支持加购',
            icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/firmIndex/label-vip.png'
        }],
        lockList: null
    },
    member: {
        unLockList: [{
            title: '律师专属名片卡',
            subtitle: '精准搜索"姓名+律师"，律师名片权威展现',
            icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/firmIndex/lawyer-card-vip.png'
        }, {
            title: '律师推荐卡',
            subtitle: '搜"地域+领域+律师", 精选认证，优先推荐',
            icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/firmIndex/lawyer-recommend-vip.png'
        }, {
            title: '律临站点推荐',
            subtitle: '律临站点律师优先推荐，加强曝光',
            icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/firmIndex/lvlin-recommend-vip.png'
        }, {
            title: '电子名片卡',
            subtitle: '专属电子名片卡，进一步提升律师形象',
            icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/firmIndex/business-card-vip.png'
        }, {
            title: '个人站点',
            subtitle: '专属律师主页，个性化自定义配置，会员严选标识进一步提升律师品牌形象',
            icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/firmIndex/personal-site-vip.png'
        }],
        lockList: null
    },
    effect: {
        unLockList: [{
            title: '即时线索',
            subtitle: '每月会员免费认领高意向线索，自由挑选接触转化',
            icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/firmIndex/clue-vip.png'
        }, {
            title: '公开咨询',
            subtitle: '海量级线索，会员回复咨询优先获得线索，无限畅领',
            icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/firmIndex/consult-vip.png'
        // }, {
        //     title: '付费电话咨询',
        //     subtitle: '用户诉求定向触达律师，提供付费咨询方式，高效变现',
        //     icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/firmIndex/phone-vip.png'
        // }, {
        //     title: 'IM咨询',
        //     subtitle: '用户在线咨询，12小时客户独占保护',
        //     icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/firmIndex/im-vip.png'
        }],
        lockList: null
    },
    tool: {
        unLockList: [{
            title: 'AI合同助手',
            subtitle: '一键上传资料，系统A1智能分析材料，80%业务2小时内即可出函',
            icon: 'https://lvlin-base.cdn.bcebos.com/fe-saas/page/firmIndex/ai-vip.png'
        }],
        lockList: null
    }
};